<!--<app-button (btnClicked)="authService.logout()">-->
<!--  <div>Logout</div>-->
<!--</app-button>-->
@if (userService.isAdmin()) {
  <app-admin-layout></app-admin-layout>
} @else {
  <app-client-layout></app-client-layout>
}
